import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';
import { ImportComponentDesignMenuItem } from '../shared-menu-items/ImportComponentDesignMenuItem';

export function ComponentDesignsContainerMenu() {
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="componentDesign" />
      <ImportComponentDesignMenuItem />
    </SceneMenuContent>
  );
}
